export const UPDATE_BLEMISH_REPORT_REQUEST = 'UPDATE_BLEMISH_REPORT_REQUEST';
export const UPDATE_BLEMISH_REPORT_SUCCESS = 'UPDATE_BLEMISH_REPORT_SUCCESS';
export const UPDATE_BLEMISH_REPORT_FAILURE = 'UPDATE_BLEMISH_REPORT_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/questions_constants/update_blemish_report.constants.js